<button mat-dialog-title mat-mini-fab color="primary" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.CreateObjectTypeClassDialog.CreateHeadline' | translate : 'Create Object type class' }}">
    <mat-tab-group>
      <mat-tab label="{{ 'Turbo.Settings.CreateObjectTypeClassDialog.tabGeneral' | translate : 'General' }}">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.CreateObjectTypeClassDialog.lblName' | translate : 'Name' }}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="otc.Name" [disabled]="!data.editable">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.CreateObjectTypeClassDialog.lblDescription' | translate : 'Description' }}</mat-label>
          <textarea matInput [(ngModel)]="otc.Description" [disabled]="!data.editable"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.CreateObjectTypeClassDialog.lblOverrideClassId' | translate : 'Override Class' }}</mat-label>
          <mat-select [ngModel]="otc.OverridesClassId" (ngModelChange)="onOverridenClassSelected($event)" [disabled]="!data.editable">
            <mat-option *ngFor="let type of objectTypeclasses" [value]="type.Id">
              {{ type.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </t4-container>
</mat-dialog-content>
@if(data.editable) {
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!otc.Name" (click)="save()">{{ 'Turbo.Settings.CreateObjectTypeClassDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
}
@else {
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" [mat-dialog-close]>{{ 'Turbo.Settings.CreateObjectTypeClassDialog.cmdClose' | translate : 'Close' }}</button>
</mat-dialog-actions>
}

